export const FEATURE_FLAG_COOKIE_NAME = 'x-flag'
export const FEATURE_FLAG_HEADER_NAME = 'X-Flag'

export const flags = {
  FLAG_FOR_TESTING: 'pga-com-flag-for-testing',
  FLAG_COACH_SEARCH_INFO_VISUALIZATION: 'pga-com-coach-search-info-visualization',
  FLAG_COACHES_SEARCH_PRIORITY: 'pga-com-coaches-search-priority',
  FLAG_MEMBERS_DIFFERENTIATION: 'pga-com-members-non-members-differentiation-release',
  FLAG_CUSTOM_PAGE: 'pga-com-custom-page',
  FLAG_COACH_PLUS_BANNER: 'pga-com-coach-plus-banner',
  FLAG_SEARCH_PRECISION_RANGES: 'pga-com-search-precision-ranges',
  FLAG_MEMBERSHIP_HOLE_IN_ONE: 'pga-com-hole-in-one-registry',
}
